import classNames from 'classnames'
import TimeZonePicker from 'common/TimeZonePicker'
import styles from './index.module.scss'

type AvailabilityLegendProps = {
  containerClassName?: string
}

const AvailabilityLegend: React.FC<AvailabilityLegendProps> = ({
  containerClassName = '',
}) => {
  return (
    <div
      className={classNames(
        styles.availability_legend_container,
        containerClassName
      )}
    >
      <div className={styles.timezone_container}>
        <span>Clients will be booked in</span>
        <TimeZonePicker
          containerClass={`${styles.timezone_picker}`}
          showClientMsgHint={false}
          fontSize={16}
        />
      </div>
    </div>
  )
}

export default AvailabilityLegend
